import { Component, Input, OnInit } from '@angular/core';
import { ResumoOrcamento } from 'src/app/pages/orcamento/listagem/todos-orcamentos.component';

@Component({
  selector: 'app-carousel-resumo-orcamentos',
  templateUrl: './carousel-resumo-orcamentos.component.html',
  styleUrls: ['./carousel-resumo-orcamentos.component.css', './carousel-resumo-orcamentos.component.scss']
})
export class CarouselResumoOrcamentosComponent implements OnInit {
  @Input() jsonDados: ResumoOrcamento = new ResumoOrcamento();
  constructor() { }

  ngOnInit(): void {
    this.jsonDados.sumTotal();
  }

}